import React from "react";
import { colorData } from "../data/brandData";
import ColorCard from "./ColorCard";
import "../styles/colorPalette.css";

const ColorPalette: React.FC = () => {
  return (
    <div className="color-palette">
      <h2>Main Color Palette</h2>
      <div className="color-showcase">
        {colorData.map((color) => (
          <ColorCard
            key={color.name}
            colorName={color.name}
            hexValue={color.hex}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPalette;
